import styles from './FilterSelector.module.css'
import { useEffect, useRef, useState } from 'react'
import { FilterSelectorDrawer } from './FilterSelectorDrawer'
import { FilterSelectorButton } from './FilterSelectorButton'
import { FilterSelectorPopper } from './FilterSelectorPopper'
import { useMediaQuery } from 'usehooks-ts'
import { BreakPointsWidth } from 'shared/enums/BreakPointsWidth'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'



interface FilterSelectorProps {
    text: string
    propertyName?: string
    items: any[]
    initialSelectedItems: any[]
    open: boolean
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onSelectedItemsChanged?: (event: any) => void
    onClearFilter?: (event: any) => void
}


export const FilterSelector = (props: FilterSelectorProps) => {
    const {
        text,
        items,
        open,
        propertyName,
        onOpen,
        onClose,
        initialSelectedItems,
        onSelectedItemsChanged,
        onClearFilter
    } = props

    const [selectedItems, setSelectedItems] = useState<any[]>([])
    const buttonRef = useRef()
    const isMediumDevice = useMediaQuery(`only screen and (min-width : ${BreakPointsWidth.md}px)`)

    const handleButtonClick = (event: any) => {
        onOpen?.(propertyName)
    }

    const handleFilterSelectorDrawerClose = (event: any) => {
        onClose?.(event)
    }

    const handleSelectedItemsChanged = (event: any) => {
        //onSelectedItemsChanged?.({
        //    propertyName: propertyName,
        //    selectedItems: event
        //})
    }

    const handleSelectItemChange = (event: any) => {
        const {
            name,
            checked
        } = event

        if (checked === true) {
            setSelectedItems((prev: any) => {
                //const result = [...prev, name]
                const result = [name]
                return result
            })

            return
        }

        if (checked === false) {
            setSelectedItems((prev: any) => {
                return prev.filter((item: any) => {
                    return (item !== name)
                })
            })

            return
        }
    }

    const handleApplyFilter = () => {
        onSelectedItemsChanged?.({
            propertyName: propertyName,
            selectedItems: selectedItems
        })
    }

    const handleClearFilter = (event: any) => {
        setSelectedItems([])
    }

    useEffect(() => {
        setSelectedItems(initialSelectedItems)
    }, [
        initialSelectedItems
    ])

    const value = initialSelectedItems.length > 0 ? initialSelectedItems[0]: undefined
    const caption = text
    const isXlWidthScreenOrMore = useBreakpointUp('xl')

    return (
        <div className={styles.FilterSelector}>
            <div className={styles.FilterSelector__Caption}>{caption}</div>
            <FilterSelectorButton
                className={styles.FilterSelectorButton}
                onClick={handleButtonClick}
                caption={caption}
                value={value}
                ref={buttonRef}
                open={open}
            />
            <FilterSelectorPopper
                open={open}
                text={text}
                anchor={isXlWidthScreenOrMore ? buttonRef: null}
                items={items}
                selectedItems={selectedItems}
                onClose={handleFilterSelectorDrawerClose}
                onApplyFilter={handleApplyFilter}
                onSelectItemChange={handleSelectItemChange}
                onClearFilter={handleClearFilter}
            />
        </div>
    )
}